<template>
  <div class="datav-map-visit-list">
    <transition-group name="el-zoom-in-center">
      <div v-for="(item, index) in userEvent" :key="item.eventid" class="flex align-items-center card" :style="{ 'transition-delay': 0.1 * index + 's' }">
        <div class="hd">
          <f-user-avatar :src="item.binder_avatar" size="small" />
        </div>
        <div class="ml bd ellipsis"><span>{{ item.binder_name || '佚名' }}</span></div>
        <div class="ft ellipsis"><el-link class="dark-link" :underline="false" @click="emitClick(item)" @mouseenter.native="emitHover(item)">{{ item.equip_name }}</el-link></div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { getLatestVisitApi } from '@/api/rms/rmsEventApi'
export default {
  data() {
    return {
      userEvent: [],

      timerId: null,
      pingCounter: 0,
      pingCt: 5,
    }
  },

  created() {
    this.getRecentUserEvent()
    this.initInterval()
  },

  beforeDestroy() {
    this.stopInterval()
  },

  methods: {
    initInterval() {
      var _this = this
      _this.pingCounter = 0
      _this.stopInterval()
      this.timerId = setInterval(function() {
        // 周期ping
        _this.pingCounter += 1
        if (_this.pingCounter >= _this.pingCt) {
          _this.pingCounter = 0
          _this.getRecentUserEvent()
        }
      }, 1000)
    },
    stopInterval() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = null
      }
    },

    getRecentUserEvent() {
      getLatestVisitApi({ num: 10 }).then(res => {
        if (!res.errno) {
          this.userEvent = res.data.list
        }
      })
    },

    emitClick(item) {
      this.$emit('equip-click', item.equipid)
    },

    emitHover(item) {
      this.$emit('equip-hover', item.equipid)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-top: 10px;
  padding: 8px 10px 7px 10px;
  border-radius: 5px;
  background-color: rgba(128, 128, 128, .1);
  transition-duration: .5s;
  transition-timing-function: ease-out;
}
</style>
